module.exports = __webpack_public_path__ + "img/icon-info.7ecbdd04.svg";